import styled from 'styled-components'

export const Container = styled.section`
  grid-area: about;
  margin-inline-start: 1rem;
  margin-inline-end: 1rem;
  margin-top: 2rem;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`
